/* Gogo Language Texts

Table of Contents

01.General
02.User Login, Logout, Register
03.Menu
04.Dashboards
05.Pages
06.Applications
  06.01.Chat
  06.02.Survey
  06.03.Todo
07.UI
  07.01.Alerts
  07.02.Badges
  07.03.Buttons
  07.04.Cards
  07.05.Carousel
  07.06.Charts
  07.07.Collapse
  07.08.Dropdowns
  07.09.Editors
  07.10.Forms
  07.11.Form Components
  07.12.Icons
  07.13.Input Groups
  07.14.Jumbotron
  07.15.Modal
  07.16.Navigation
  07.17.Popover & Tooltip
  07.18.Sortable
  07.19.Maps
  07.20.Tables
*/

const arMessages = {
  /* 01.General */
  'general.copyright': 'Myma.ai © 2019 All Rights Reserved.',

  /* 02.User Login, Logout, Register */
  'user.login-title': 'تسجيل الدخول',
  'user.register': 'يسجل',
  'user.forgot-password': 'هل نسيت كلمة السر',
  'user.email': 'بريد إلكتروني',
  'user.newpassword': 'كلمة سر جديدة',
  'user.currentpassword': 'كلمة المرور الحالي',
  'user.newpasswordagain': 'كلمة المرور الجديدة مرة أخرى',
  'user.password': 'كلمة المرور',
  'user.forgot-password-question': 'نسيت كلمة المرور؟',
  'user.fullname': 'الاسم بالكامل',
  'user.firstname': 'الاسم الاول',
  'user.lastname': 'الكنية',
  'user.login-button': 'تسجيل الدخول',
  'user.register-button': 'تسجيل',
  'user.reset-password-button': 'إعادة تعيين',
  'user.buy': 'يشترى',
  'user.username': 'اسم المستخدم',

  /* 03.Menu */
  'menu.app': 'مسكن',

  'menu.default': 'تقصير',
  'menu.analytics': 'تحليلات',
  'menu.ecommerce': 'التجارة الإلكترونية',
  'menu.content': 'المحتوى',
  'menu.pages': 'الصفحات',
  'menu.data-list': 'قائمة البيانات',
  'menu.thumb-list': 'قائمة الصور المصغرة',
  'menu.image-list': 'قائمة الصور',
  'menu.details': 'تفاصيل',
  'menu.search': 'بحث',
  'menu.login': 'تسجيل الدخول',
  'menu.register': 'تسجيل',
  'menu.forgot-password': 'نسيت كلمة المرور',
  'menu.error': 'خطأ',
  'menu.applications': 'التطبيقات',
  'menu.todo': 'قائمة المهام',
  'menu.survey': 'استبيان',
  'menu.chat': 'دردشة',
  'menu.ui': 'واجهة المستخدم',
  'menu.edit': 'تحرير',
  'menu.alerts': 'التنبيهات',
  'menu.badges': 'الشارات',
  'menu.buttons': 'الأزرار',
  'menu.cards': 'البطاقات',
  'menu.carousel': 'شريط التمرير',
  'menu.charts': 'الرسوم البيانية',
  'menu.collapse': 'طي',
  'menu.dropdowns': 'القوائم المنسدلة',
  'menu.editors': 'المحررات',
  'menu.form-layouts': 'تخطيطات النماذج',
  'menu.form-components': 'مكونات النماذج',
  'menu.form-validations': 'التحقق من النماذج',
  'menu.icons': 'الرموز',
  'menu.input-groups': 'مجموعات الإدخال',
  'menu.jumbotron': 'جومبوترون',
  'menu.modal': 'نافذة منبثقة',
  'menu.navigation': 'التنقل',
  'menu.popover-tooltip': 'النافذة المنبثقة والتلميحات',
  'menu.sortable': 'قابل للفرز',
  'menu.tables': 'الجداول',
  'menu.menu': 'القائمة',
  'menu.subhidden': 'فرعية مخفية',
  'menu.hidden': 'مخفي',
  'menu.visible': 'مرئي',
  'menu.maps': 'الخرائط',
  'menu.landingpage': 'الصفحة المقصودة',
  'menu.multipage-home': 'الصفحة الرئيسية متعددة الصفحات',
  'menu.singlepage-home': 'الصفحة الرئيسية أحادية الصفحة',
  'menu.about': 'حول',
  'menu.auth-login': 'تسجيل الدخول (المصادقة)',
  'menu.auth-register': 'تسجيل (المصادقة)',
  'menu.blog': 'المدونة',
  'menu.blog-detail': 'تفاصيل المدونة',
  'menu.careers': 'الوظائف',
  'menu.confirmation': 'التأكيد',
  'menu.contact': 'اتصل بنا',
  'menu.docs': 'الوثائق',
  'menu.features': 'الميزات',
  'menu.prices': 'الأسعار',
  'menu.videos': 'الفيديوهات',
  'menu.mailing': 'المراسلات',
  'menu.invoice': 'فاتورة',
  'menu.blank-page': 'قريباً...',
  'menu.types': 'أنواع القوائم',
  'menu.levels': 'مستويات القائمة',
  'menu.third-level-1': 'المستوى الثالث 1',
  'menu.third-level-2': 'المستوى الثالث 2',
  'menu.third-level-3': 'المستوى الثالث 3',


  /* 04.Dashboards */
  'dashboards.update': 'تحديث',
  'dashboards.save': 'حفظ',
  'dashboards.name': 'الاسم',
  'dashboards.button': 'زر',
  'dashboards.visits': 'زيارات',
  'dashboards.checkAvailability': 'تحقق من التوافر أو الأسعار',
  'dashboards.details': 'تفاصيل',
  'dashboards.pending-orders': 'الأوامر المعلقة',
  'dashboards.completed-orders': 'الطلبات المكتملة',
  'dashboards.refund-requests': 'طلبات الاسترداد',
  'dashboards.new-comments': 'تعليقات جديدة',
  'dashboards.sales': 'مبيعات',
  'dashboards.orders': 'الطلب #٪ s',
  'dashboards.refunds': 'المبالغ المستردة',
  'dashboards.recent-orders': 'الطلبيات الأخيرة',
  'dashboards.product-categories': 'فئات المنتجات',
  'dashboards.cakes': 'كيك',
  'dashboards.tickets': 'تذاكر',
  'dashboards.calendar': 'التقويم',
  'dashboards.best-sellers': 'أفضل البائعين',
  'dashboards.per-session': 'لكل جلسة',
  'dashboards.profile-status': 'حالة الملف الشخصي',
  'dashboards.payment-status': 'حالة السداد',
  'dashboards.work-progress': 'سير العمل',
  'dashboards.tasks-completed': 'اكتملت المهام',
  'dashboards.payments-done': 'تم الدفع',
  'dashboards.order-stock': 'طلب - مخزون',
  'dashboards.categories': 'فئات',
  'dashboards.quick-post': 'بوست سريع',
  'dashboards.title': 'لقب',
  'dashboards.content': 'المحتوى',
  'dashboards.ticket-count': '	عدد التذاكر',
  'dashboards.commonticketsubmission': '	الطلبات الشائعة للتذاكر',
  'dashboards.category': 'فئة',
  'dashboards.save-and-publish': 'احفظ وانشر',
  'dashboards.top-viewed-posts': 'أعلى المشاركات مشاهدة',
  'dashboards.posts': 'دعامات',
  'dashboards.pending-for-publish': 'في انتظار النشر',
  'dashboards.users': 'المستخدمون',
  'dashboards.on-approval-process': 'في عملية الموافقة',
  'dashboards.alerts': 'تنبيهات',
  'dashboards.waiting-for-notice': 'في انتظار إشعار',
  'dashboards.files': 'الملفات',
  'dashboards.pending-for-print': 'في انتظار الطباعة',
  'dashboards.logs': 'السجلات',
  'dashboards.gogo': 'جوجو',
  'dashboards.magic-is-in-the-details': 'السحر في التفاصيل',
  'dashboards.yes-it-is-indeed': 'نعم إنه كذلك بالفعل!',
  'dashboards.advanced-search': 'البحث المتقدم',
  'dashboards.toppings': 'الأغطية',
  'dashboards.type': 'يكتب',
  'dashboards.keyword': 'الكلمة الرئيسية',
  'dashboards.search': 'يبحث',
  'dashboards.top-rated-items': 'العناصر الأعلى تقييما',
  'dashboards.country': 'البلد',
  'dashboards.webVisitors': 'زوار الموقع',
  'dashboards.avatarClicks': 'نقرات الصورة الرمزية',
  'dashboards.wordCloud': 'سحابة الكلمات',
  'dashboards.topic': 'عنوان',
  'dashboards.roomsAvailability': 'الغرف والتوافر',
  'dashboards.startChat': 'بدء محادثة',
  'dashboards.restaurantsBars': 'مطاعم وبارات',
  'dashboards.groupBooking': 'حجز جماعي',
  'dashboards.promotions': 'العروض الترويجية',
  'dashboards.weedingevents': 'حفل & فعاليات',
  'dashboards.lostsomething': 'فقدت شيئاً',
  'dashboards.producttext': 'نص المنتج',
  'dashboards.bookingroomnew': 'حجز غرفة جديدة',
  'dashboards.email': 'البريد الإلكتروني',
  'dashboards.phone': 'الهاتف',
  'dashboards.zipcode': 'الرمز البريدي',
  'dashboards.marketingconsent': 'موافقة التسويق',
  'dashboards.additionalinfo': 'معلومات إضافية',
  'dashboards.viewallcontacts': 'عرض جميع جهات الاتصال',
  'dashboards.current': 'الحالي',
  'dashboards.last7days': 'آخر 7 أيام',
  'dashboards.last30days': 'آخر 30 يومًا',
  'dashboards.thisweek': 'هذا الأسبوع',
  'dashboards.thismonth': 'هذا الشهر',
  'dashboards.previousmonth': 'الشهر الماضي',
  'dashboards.yeartodate': 'من بداية السنة حتى الآن',
  'dashboards.lastyear': 'العام الماضي',
  'dashboards.all': 'الكل',
  'dashboards.standardOccupancy': 'الإشغال القياسي',
  'dashboards.max-occupancy': 'الحد الأقصى للإشغال',
  'dashboards.numberOfThisType': 'عدد هذا النوع',
  'dashboards.displayOrder': 'ترتيب العرض',
  'dashboards.provider': 'المزود',
  'dashboards.edit': 'تحرير',
  'dashboards.delete': 'حذف',
  'dashboards.addImages': 'إضافة صور',
  'dashboards.location_ip': 'الموقع تقريبي ويُحدد حسب عنوان IP',
  'dashboards.near': 'بالقرب من',
  'dashboards.referral': 'تمت الإحالة عن طريق هذا الموقع',
  'dashboards.calling_party': 'المتصل (الطرف المستقبل)',
  'dashboards.called_party': 'الطرف المتلقى',
  'dashboards.lastdial': 'آخر اتصال',
  'dashboards.imagelink': 'رابط الصورة',
  'dashboards.browsegallery': 'استعراض المعرض',
  'dashboards.changelog': 'سجل التغييرات',
  'dashboards.externalresources': 'موارد خارجية',
  'dashboards.webpage': 'صفحة ويب',
  'dashboards.web-pages': 'صفحات الويب',
  'dashboards.published': 'تم النشر',
  'dashboards.adddocument': 'إضافة مستند',
  'dashboards.ready-to-publish': 'جاهز للنشر',
  'dashboards.draft': 'مسودة',
  'dashboards.order-by': 'ترتيب حسب',
  'dashboards.add-faq': 'إضافة سؤال شائع',
  'dashboards.collections': 'المجموعات',
  'dashboards.items': 'عناصر',
  'dashboards.rooms-availability': 'الغرف والتوافر',
  'dashboards.events-wedding-venues': 'الفعاليات وقاعات الزفاف',
  'dashboards.long-stay-enquiry': 'استعلام الإقامة الطويلة',
  'dashboards.reservation-confirmation-request': 'طلب تأكيد الحجز',
  'dashboards.modify-cancel-booking': 'تعديل أو إلغاء الحجز',
  'dashboards.left-something-behind': 'نسيت شيئًا خلفك',
  'dashboards.invoice-copy': 'نسخة من الفاتورة / الإيصال',
  'dashboards.sync': 'مزامنة',
  'dashboards.add-web-page': 'إضافة صفحة ويب',
  'dashboards.sprint-title': 'تعرف على Sprint، أداة الأتمتة الرائدة لتدريب نموذج الذكاء الاصطناعي في وقت أقل بعشر مرات.',
  'dashboards.sprint-description': 'يعمل Sprint إلى جانبك — لإطلاق العنان للإبداع، وزيادة الإنتاجية، وتقليل الوقت المطلوب لتدريب المساعد الرقمي بشكل كبير.',
  'dashboards.sprint-feature': 'تم تصميم ميزة Sprint لمزامنة المعرفة من مصادر خارجية، مما يجعلها ذات قيمة سواء للتثبيت الأولي أو لتحديث البيانات المستمر. عند تشغيلها على نظام نشط، تقوم Sprint بتعديل مركز المعرفة بناءً على المصادر الخارجية التي قمت بتكوينها، مما يمكن أن يؤثر مباشرة على السلوكيات والاستجابات التي يولدها الذكاء الاصطناعي. لمساعدتك في إعداد Sprint، يُرجى الاتصال بفريق الدعم.',
  'dashboards.change-password': 'تغيير كلمة المرور',
  'dashboards.sign-out': 'تسجيل الخروج',
  'dashboards.privacy-policy': 'سياسة الخصوصية',
  'dashboards.help-center': 'مركز المساعدة',
  'dashboards.switch-account': 'تبديل الحساب',
  'dashboards.business-settings': 'إعدادات العمل',
  'dashboards.notifications-allowed': 'الإشعارات مسموحة',
  'dashboards.dark-theme': 'الموضوع الداكن',
  'dashboards.online': 'متصل',
  'dashboards.offline': 'غير متصل',
  'dashboards.invoice-&-payments': 'الفواتير والمدفوعات',
  'dashboards.upgrade-plan': 'ترقية الخطة',
  'dashboards.add-room': 'إضافة غرفة',
  'dashboards.room-type': 'نوع الغرفة',
  'dashboards.room-name': 'اسم الغرفة',
  'dashboards.how-many-guests': 'كم عدد الضيوف الذين يمكنهم الإقامة في هذه الغرفة؟',
  'dashboards.number-of-rooms-this-type': 'عدد الغرف (من هذا النوع)',
  'dashboards.number-of-bedrooms': 'عدد غرف النوم',
  'dashboards.number-of-livingrooms': 'عدد غرف المعيشة',
  'dashboards.minimum-adults': 'الحد الأدنى للبالغين',
  'dashboards.maximum-adults': 'الحد الأقصى للبالغين',
  'dashboards.maximum-children': 'الحد الأقصى للأطفال',
  'dashboards.maximum-infants': 'الحد الأقصى للرضّع',
  'dashboards.extra-beds-allowed': 'سماح بأسرة إضافية',
  'dashboards.booking-engine-code': 'رمز نظام الحجز',
  'dashboards.room-size': 'مساحة الغرفة',
  'dashboards.balcony-area': 'مساحة الشرفة',
  'dashboards.unit': 'وحدة',
  'dashboard.whatsapp_message': 'اكتب رسالتك هنا...',
  'dashboard.whatsapp_reply_window': 'لديك نافذة مدتها 24 ساعة للرد على رسالة العميل على واتساب للأعمال من وقت آخر رسالة أرسلها العميل. إذا قمت بالرد خلال نافذة خدمة العملاء التي تبلغ 24 ساعة، يمكنك إرسال أي نوع من الرسائل. بعد إغلاق نافذة الـ24 ساعة، يمكنك فقط إرسال الرسائل باستخدام قوالب الرسائل المعتمدة مسبقًا، والتي تعيد تشغيل نافذة الـ24 ساعة عند رد العميل.',
  'dashboards.square-meters': 'أمتار مربعة',
  "dashboard.pick_quick_reply": "اختر ردًا سريعًا أو اكتب رسالتك",
  "dashboard.hang_in_there": "يرجى الانتظار بينما نحاول الاتصال بك!",
  "dashboard.outbound_msg": "موعد إرسال الرسالة الصادرة",
  "dashboard.message_sent": "تم إرسال رسالتك بنجاح!",
  "dashboard.failed_msg": "فشل في إرسال الرسالة",
  "dashboard.new_chat_message": "رسالة دردشة جديدة",
  "dashboard.user_msg": "توجد رسالة من المستخدم خلال آخر 24 ساعة، يمكنك إرسال أي رسالة كرد. هل ما زلت تريد إرسال رسالة القالب هذه أم الرد بأي رسالة؟",
  "dashboard.us_number": "لا يتم إرسال رسائل WhatsApp للأعمال إلى الأرقام الأمريكية لأن Meta أوقفت جميع الرسائل التسويقية إلى الأرقام الأمريكية في 1 أبريل 2025.",
  "dashboard.error_msg": "يرجى إكمال جميع الحقول النائبة بشكل صحيح.",

  'web-widget.title': 'قوائم عنصر الويب للدردشة على الموقع',
  /* Home Page */
  'dashboards.quickstartwithai': 'البداية السريعة مع الذكاء الاصطناعي',
  'dashboards.fastestpathtoautomation': 'أنت على أسرع طريق لأتمتة باستخدام أدوات الذكاء الاصطناعي',
  'dashboards.insightsthatempower': 'رؤى تمكّن',
  'dashboards.trainchatbot': 'تدريب الروبوت الحواري',
  'dashboards.automatewithforms': 'أتمتة باستخدام النماذج',
  'dashboards.inroomdigitalcompendium': 'دليل رقمي داخل الغرفة',
  'dashboards.support': 'الدعم',
  'dashboards.helpcenter': 'مركز المساعدة',
  'dashboards.searchfaqintegrations': 'ابحث عن مقالات حول الأسئلة الشائعة الشائعة والتكاملات والمزيد.',
  'dashboards.asklivechat': 'اسأل فريقنا عبر الدردشة المباشرة',
  'dashboards.inroomqrcode': 'رمز QR داخل الغرفة لعرض معلومات عن العقار والموقع',
  'dashboards.customizewebwidget': 'خصص وأضف عنصر الويب إلى موقعك مع روبوت الدردشة الذكي المدمج',
  'dashboards.createcustomforms': 'أنشئ نماذج مخصصة واحصل على إشعارات عند إرسال الضيف للنموذج',
  'dashboards.trainchatbotproperty': 'درب روبوت الدردشة بمعلومات عن العقار مثل وقت تسجيل الوصول والأنشطة، إلخ',
  'dashboards.chatbotinsights': 'اطّلع على كيفية تفاعل روبوت الدردشة مع الضيوف واكتساب رؤى حول الإحصاءات مثل زوار الموقع، الأسئلة الشائعة، والمزيد.',
  'dashboards.addaichatbottoyourwebsite': 'أضف روبوت دردشة ذكي (AI) إلى موقعك',

  /* Email Stats  */
  'dashboards.thread-summary-title': 'ملخصات المحادثات',
  'dashboards.thread-summary-subtitle': 'ملخصات البريد الإلكتروني التي تم إنشاؤها بواسطة الذكاء الاصطناعي',
  'dashboards.ai-replies-title': 'ردود الذكاء الاصطناعي',
  'dashboards.ai-replies-subtitle': 'ردود تم إنشاؤها بواسطة الذكاء الاصطناعي',

  'dashboards.total-thread-summary-title': 'إجمالي ملخصات المحادثات المُنشأة',
  'dashboards.total-ai-replies-title': 'إجمالي ردود الذكاء الاصطناعي المُنشأة',
  'dashboards.total-draft-copied': 'المسودات التي نسخها المستخدمون',

  'dashboards.urgency': 'درجة الإلحاح',
  'dashboards.sentiment': 'المشاعر',

  'dashboards.common-email-reasons': 'أسباب شائعة للبريد الإلكتروني',
  'dashboards.topics-in-emails': 'المواضيع في رسائل البريد الإلكتروني',

  'dashboards.email-assistant-usage': 'استخدام مساعد البريد الإلكتروني بالذكاء الاصطناعي',
  'dashboards.usage-by-email-address': 'الاستخدام حسب عناوين البريد الإلكتروني',

  /* 05.Pages */
  'pages.title.dashboards.analytics': 'تحليلات',
  'pages.title.ari': 'التوفر والأسعار',
  'pages.title.conversations': 'المحادثات',
  'pages.title.bookings': 'الحجوزات والحجوزات',
  'pages.title.tickets': 'العروض والتذاكر',
  'pages.title.propinfo': 'استجابات',
  'pages.title.discounts': 'الخصومات والعروض',
  'pages.title.finance': 'تمويل',
  'pages.title.integration': 'الإدماج',
  'pages.title.admin': 'مسؤل',
  'pages.add-new': 'اضف جديد',
  'pages.add-new-modal-title': 'أضف أداة جديدة',
  'pages.display-options': 'خيارات العرض',
  'pages.orderby': 'ترتيب حسب :',
  'pages.product-name': 'اسم المنتج',
  'pages.category': 'فئة',
  'pages.description': 'وصف',
  'pages.status': 'حالة',
  'pages.cancel': 'يلغي',
  'pages.submit': 'إرسال',
  'pages.delete': 'حذف',
  'pages.another-action': 'عمل آخر',
  'pages.actions': 'أجراءات',
  'pages.header': 'رأس',
  'pages.details': 'تفاصيل',
  'pages.orders': 'الطلب #٪ S',
  'pages.rating': 'تقييم',
  'pages.price': 'السعر',
  'pages.ingredients': 'مكونات',
  'pages.is-vegan': 'نباتي',
  'pages.order-status': 'حالة الطلب',
  'pages.bake-progress': 'تقدم خبز',
  'pages.popularity': 'شعبية',
  'pages.comments': 'تعليقات',
  'pages.error-title': 'عفوًا ... يبدو أنه حدث خطأ!',
  'pages.error-code': 'خطا بالكود',
  'pages.go-back-home': 'ارجع الى البيت',
  'pages.mailing-info':
    'تستخدم قوالب البريد أسلوبًا مضمنًا وتخطيطًا للجدول ليتم عرضها جيدًا في مختلف موفري الخدمات. لتوفير قابلية استخدام أفضل ، نقوم بتضمينها على أنها لغة تأشير النص الفائق (html) العادية مع لغة StInnerHTML بشكل خطير.',
  'pages.invoice-info':
    'يحتوي نموذج الفاتورة على إصدار مضمن للاستخدام خارج المشروع بالإضافة إلى إصدار React.',
  'pages.react-version': 'رد الفعل الإصدار',
  'pages.inline-version': 'إصدار Html بنمط مضمّن',

  /* 06.Applications */

  /* 06.01.Chat */
  'chat.messages': 'رسائل',
  'chat.contacts': 'جهات الاتصال',
  'chat.saysomething': 'قل شيئا..',

  /* 06.02.Survey */
  'survey.delete': 'حذف',
  'survey.edit': 'تعديل',
  'survey.add-new': 'اضف جديد',
  'survey.add-new-title': 'إضافة استبيان جديد',
  'survey.title': 'لقب',
  'survey.category': 'فئة',
  'survey.label': 'مُلصَق',
  'survey.status': 'حالة',
  'survey.cancel': 'يلغي',
  'survey.submit': 'إرسال',
  'survey.another-action': 'عمل آخر',
  'survey.display-options': 'خيارات العرض',
  'survey.orderby': 'ترتيب حسب :',
  'survey.all-surveys': 'جميع الاستطلاعات',
  'survey.completed-surveys': 'استطلاعات الرأي المكتملة',
  'survey.categories': 'فئات',
  'survey.active-surveys': 'المسوحات النشطة',
  'survey.labels': 'ملصقات',

  /* 06.03.Todo */
  'todo.add-new': 'اضف جديد',
  'todo.add-new-title': 'إضافة تودو جديد',
  'todo.title': 'لقب',
  'todo.detail': 'التفاصيل',
  'todo.category': 'فئة',
  'todo.label': 'مُلصَق',
  'todo.status': 'حالة',
  'todo.cancel': 'يلغي',
  'todo.submit': 'إرسال',
  'todo.action': 'فعل',
  'todo.another-action': 'عمل آخر',
  'todo.display-options': 'خيارات العرض',
  'todo.orderby': 'ترتيب حسب :',
  'todo.all-tasks': 'كل المهام',
  'todo.pending-tasks': 'المهام العالقة',
  'todo.completed-tasks': 'المهام المكتملة',
  'todo.categories': 'فئات',
  'todo.labels': 'ملصقات',

  /* 07.UI */

  /* 07.01.Alerts */
  'alert.rounded': 'تنبيه ذو حواف منحنية',
  'alert.react-notifications': 'إشعارات React',
  'alert.outline': 'تنبيه بخط خارجي',
  'alert.primary': 'رئيسي',
  'alert.secondary': 'ثانوي',
  'alert.info': 'معلومات',
  'alert.success': 'نجاح',
  'alert.warning': 'تحذير',
  'alert.error': 'خطأ',
  'alert.filled': 'مملوء',
  'alert.primary-text': 'هذا تنبيه رئيسي — تحقق من ذلك!',
  'alert.secondary-text': 'هذا تنبيه ثانوي — تحقق من ذلك!',
  'alert.success-text': 'هذا تنبيه نجاح — تحقق من ذلك!',
  'alert.danger-text': 'هذا تنبيه خطر — تحقق من ذلك!',
  'alert.warning-text': 'هذا تنبيه تحذير — تحقق من ذلك!',
  'alert.info-text': 'هذا تنبيه معلومات — تحقق من ذلك!',
  'alert.light-text': 'هذا تنبيه خفيف — تحقق من ذلك!',
  'alert.dark-text': 'هذا تنبيه داكن — تحقق من ذلك!',
  'alert.default': 'تنبيه افتراضي',
  'alert.dismissing': 'تنبيه قابل للإغلاق',
  'alert.dismissing-text': 'يا إلهي! يجب عليك التحقق من بعض الحقول أدناه.',
  'alert.dismissing-without-animate-text': 'أنا تنبيه ويمكن تَغْيِيري دون رسوم متحركة!',

  /* 07.02.Badges */
  'badge.sizes': 'الأحجام',
  'badge.colors': 'الألوان',
  'badge.outline': 'حد خارجي',
  'badge.links': 'روابط',
  'badge.counter-badges': 'شارات عدّاد',
  'badge.bootstrap-default': 'Bootstrap الافتراضي',
  'badge.primary': 'رئيسي',
  'badge.secondary': 'ثانوي',
  'badge.success': 'نجاح',
  'badge.danger': 'خطر',
  'badge.warning': 'تحذير',
  'badge.info': 'معلومات',
  'badge.light': 'فاتح',
  'badge.dark': 'داكن',


  /* 07.03.Buttons */
  'button.default': 'Bootstrap الافتراضي',
  'button.colors': 'الألوان',
  'button.rounded': 'منحني الحواف',
  'button.outline': 'حد خارجي',
  'button.states': 'الحالات',
  'button.sizes': 'الأحجام',
  'button.button-groups': 'مجموعات الأزرار',
  'button.large-button': 'زر كبير',
  'button.small-button': 'زر صغير',
  'button.extra-small-button': 'زر صغير جدًا',
  'button.block-button': 'زر ممتد',
  'button.active': 'نشط',
  'button.disabled': 'معطل',
  'button.basic': 'أساسي',
  'button.toolbar': 'شريط الأدوات',
  'button.nesting': 'التداخل',
  'button.vertical-variation': 'تنوع عمودي',
  'button.checkbox-radio-button': 'مربع اختيار وزر راديو',
  'button.checkbox': 'مربع اختيار',
  'button.radio': 'راديو',
  'button.radio-button': 'زر راديو',
  'button.primary': 'رئيسي',
  'button.secondary': 'ثانوي',
  'button.success': 'نجاح',
  'button.danger': 'خطر',
  'button.warning': 'تحذير',
  'button.info': 'معلومات',
  'button.light': 'فاتح',
  'button.dark': 'داكن',
  'button.states-text': 'يُظهر هذا الزر مؤشر دوران لمدة ثانيتين، ثم أيقونة خطأ لمدة ثلاث ثوانٍ قبل العودة إلى الحالة الطبيعية. يمكن تفعيل هذه الحالات بإضافة أو إزالة الفئات.',
  'button.click-here': 'انقر هنا',
  'button.states-text-alternate': 'يُظهر هذا الزر مؤشر دوران لمدة ثانيتين، ثم أيقونة خطأ لمدة ثلاث ثوانٍ قبل العودة إلى الحالة الطبيعية. يمكن تفعيل هذه الحالات بإضافة أو إزالة الفئات.',
  'button.primary-link': 'رابط رئيسي',
  'button.link': 'رابط',
  'button.primary-button': 'زر رئيسي',
  'button.button': 'زر',
  'button.left': 'يسار',
  'button.middle': 'وسط',
  'button.right': 'يمين',
  'button.dropdown': 'قائمة منسدلة',
  'button.dropdown-link': 'رابط منسدلة',

  /* 07.04.Cards */
  'cards.icon-card': 'بطاقة بأيقونة',
  'cards.image-card': 'بطاقة صورة',
  'cards.image-overlay-card': 'بطاقة تراكب صورة',
  'cards.image-card-list': 'قائمة بطاقات صور',
  'cards.tab-card': 'بطاقة تبويب',
  'cards.user-card': 'بطاقة مستخدم',

  /* 07.05.Carousel */
  'carousel.basic': 'شريط تمرير أساسي',
  'carousel.single': 'شريط تمرير مفرد',
  'carousel.without-controls': 'شريط تمرير بدون تحكمات',

  /* 07.06.Charts */
  'charts.line': 'مخطط خطي',
  'charts.polar': 'مخطط قطبي',
  'charts.area': 'مخطط مساحة',
  'charts.scatter': 'مخطط تشتت',
  'charts.bar': 'مخطط عمودي',
  'charts.radar': 'مخطط راداري',
  'charts.pie': 'مخطط دائري',
  'charts.doughnut': 'مخطط دونات',
  'charts.shadow': 'ظل',
  'charts.no-shadow': 'بدون ظل',


  /* 07.07.Collapse */
  'collapse.basic': 'أساسي',
  'collapse.toggle': 'تبديل',
  'collapse.accordion': 'أكورديون',
  'collapse.controlled': 'خاضع للتحكم',
  'collapse.uncontrolled': 'غير خاضع للتحكم',


  /* 07.08.Dropdowns */
  'dropdowns.basic': 'أساسي',
  'dropdowns.controlled': 'خاضع للتحكم',
  'dropdowns.uncontrolled': 'غير خاضع للتحكم',
  'dropdowns.dropdown': 'قائمة منسدلة',
  'dropdowns.header': 'رأس',
  'dropdowns.action': 'إجراء',
  'dropdowns.another-action': 'إجراء آخر',
  'dropdowns.right': 'يمين',
  'dropdowns.left': 'يسار',
  'dropdowns.drop-directions': 'اتجاهات الانسداد',
  'dropdowns.dropright': 'انزلاق لليمين',
  'dropdowns.dropleft': 'انزلاق لليسار',
  'dropdowns.small-button': 'زر صغير',
  'dropdowns.large-button': 'زر كبير',
  'dropdowns.sizing': 'تعديل الحجم',
  'dropdowns.split-button': 'زر منحرف مع قائمة منسدلة',
  'dropdowns.dropup': 'انزلاق للأعلى',

  /* 07.09.Editors */
  'editors.draftjs': 'Draft.js',
  'editors.quill-standart': 'Quill القياسي',
  'editors.quill-bubble': 'Quill Bubble',


  /* 07.10.Forms */
  'forms.basic': 'أساسي',
  'forms.email': 'البريد الإلكتروني',
  'forms.email-muted': 'لن نشارك بريدك الإلكتروني مع أي أحد.',
  'forms.password': 'كلمة المرور',
  'forms.submit': 'إرسال',
  'forms.horizontal': 'أفقي',
  'forms.radios': 'راديوهات',
  'forms.first-radio': 'الراديو الأول',
  'forms.second-radio': 'الراديو الثاني',
  'forms.third-radio-disabled': 'الراديو الثالث (معطل)',
  'forms.checkbox': 'مربع اختيار',
  'forms.signin': 'تسجيل الدخول',
  'forms.top-labels-over-line': 'تسميات علوية فوق الخط',
  'forms.tags': 'علامات',
  'forms.date': 'تاريخ',
  'forms.state': 'الولاية / المحافظة',
  'forms.top-labels-in-input': 'تسميات علوية داخل الإدخال',
  'forms.email-u': 'بريد إلكتروني',
  'forms.password-u': 'كلمة مرور',
  'forms.tags-u': 'علامات',
  'forms.date-u': 'تاريخ',
  'forms.state-u': 'الولاية / المحافظة',
  'forms.grid': 'شبكة النموذج',
  'forms.address': 'العنوان',
  'forms.address2': 'العنوان 2',
  'forms.city': 'المدينة',
  'forms.city-message': 'يرجى اختيار المدينة!',
  'forms.state-message': 'يرجى اختيار الولاية / المحافظة!',
  'forms.zip': 'الرمز البريدي',
  'forms.signup': 'اشتراك',
  'forms.inline': 'متداخل (Inline)',
  'forms.validation-availity': 'تحقق Availity Reactstrap',
  'forms.validation-formik': 'تحقق Formik',
  'forms.default': 'افتراضي',
  'forms.firstname': 'الاسم الأول',
  'forms.firstname-message': 'يرجى إدخال اسمك الأول!',
  'forms.lastname': 'الاسم الأخير',
  'forms.lastname-message': 'يرجى إدخال اسمك الأخير!',


  /* 07.11.Form Components */

  'form-components.custom-inputs': 'مدخلات مخصصة',
  'form-components.checkboxes': 'خانات اختيار',
  'form-components.radios': 'أزرار راديو',
  'form-components.inline': 'محاذاة داخلية',
  'form-components.react-select': 'React Select',
  'form-components.state-single': 'حالة واحدة',
  'form-components.state-multiple': 'حالات متعددة',
  'form-components.react-autosuggest': 'اقتراح تلقائي React',
  'form-components.date-picker': 'منتقي التاريخ',
  'form-components.date': 'التاريخ',
  'form-components.date-range': 'نطاق التاريخ',
  'form-components.date-with-time': 'تاريخ مع وقت',
  'form-components.embedded': 'مضمن',
  'form-components.dropzone': 'منطقة إسقاط',
  'form-components.drop-files-here': 'أسقط الملفات هنا',
  'form-components.tags': 'الوسوم',
  'form-components.switch': 'مفتاح تبديل',
  'form-components.primary': 'رئيسي',
  'form-components.secondary': 'ثانوي',
  'form-components.primary-inverse': 'رئيسي عكسي',
  'form-components.secondary-inverse': 'ثانوي عكسي',
  'form-components.slider': 'شريط تمرير',
  'form-components.double-slider': 'شريط تمرير مزدوج',
  'form-components.single-slider': 'شريط تمرير فردي',
  'form-components.rating': 'التقييم',
  'form-components.interactive': 'تفاعلي',
  'form-components.readonly': 'للقراءة فقط',
  'form-components.type-a-cake': 'اكتب نوع الكعكة',
  'form-components.start': 'البدء',
  'form-components.end': 'النهاية',
  'form-components.tables': 'الجداول',
  /* 07.12.Icons */
  'icons.simplelineicons': 'أيقونات Simple Line',
  'icons.iconsmind': 'أيقونات Iconsmind',


  /* 07.13.Input Groups */
  'input-groups.basic': 'أساسي',
  'input-groups.sizing': 'تحديد الحجم',
  'input-groups.small': 'صغير',
  'input-groups.default': 'افتراضي',
  'input-groups.large': 'كبير',
  'input-groups.checkboxes-and-radios': 'خانات اختيار وأزرار راديو',
  'input-groups.multiple-inputs': 'مدخلات متعددة',
  'input-groups.first-and-last-name': 'الاسم الأول واسم العائلة',
  'input-groups.multiple-addons': 'إضافات متعددة',
  'input-groups.button-addons': 'إضافات الأزرار',
  'input-groups.button': 'زر',
  'input-groups.buttons-with-dropdowns': 'أزرار مع قوائم منسدلة',
  'input-groups.dropdown': 'قائمة منسدلة',
  'input-groups.header': 'رأس',
  'input-groups.action': 'إجراء',
  'input-groups.another-action': 'إجراء آخر',
  'input-groups.custom-select': 'تحديد مخصص',
  'input-groups.options': 'الخيارات',
  'input-groups.choose': 'اختر...',
  'input-groups.custom-file-input': 'إدخال ملف مخصص',


  /* 07.14.Jumbotron */
  'jumbotron.hello-world': 'مرحبًا بالعالم!',
  'jumbotron.lead': 'هذه وحدة بطل بسيطة، مكون بأسلوب جامبوترون لجذب الانتباه إلى المحتوى أو المعلومات المميزة.',
  'jumbotron.lead-detail': 'تستخدم فئات المساعدة للطباعة والتباعد لتوزيع المحتوى داخل الحاوية الأكبر.',
  'jumbotron.learn-more': 'اعرف المزيد',


  /* 07.15.Modal */
  'modal.basic': 'أساسي',
  'modal.modal-title': 'عنوان النافذة',
  'modal.launch-demo-modal': 'تشغيل نافذة العرض',
  'modal.scrolling-long-content': 'محتوى طويل قابل للتمرير',
  'modal.backdrop': 'الخلفية',
  'modal.backdrop-value': 'قيمة الخلفية',
  'modal.right-modal': 'نافذة منبثقة على اليمين',
  'modal.launch-right-modal': 'تشغيل النافذة اليمنى',
  'modal.nested-modal': 'نافذة متداخلة',
  'modal.size': 'الحجم',
  'modal.launch-large-modal': 'تشغيل نافذة كبيرة',
  'modal.launch-small-modal': 'تشغيل نافذة صغيرة',


  /* 07.16.Navigation */
  'nav.basic': 'تنقل أساسي',
  'nav.active': 'نشط',
  'nav.disabled': 'معطل',
  'nav.disabled-link': 'رابط معطل',
  'nav.link': 'رابط',
  'nav.longer-link': 'رابط تنقل أطول',
  'nav.another-link': 'رابط آخر',
  'nav.right': 'يمين',
  'nav.dropdown': 'قائمة منسدلة',
  'nav.header': 'رأس',
  'nav.action': 'إجراء',
  'nav.another-action': 'إجراء آخر',
  'nav.horizontal-alignment': 'محاذاة أفقية',
  'nav.vertical-alignment': 'محاذاة عمودية',
  'nav.pills': 'علامات تنقلية (Pills)',
  'nav.fill-justify': 'ملء وتوزيع متساوي',
  'nav.pills-dropdowns': 'علامات مع قوائم منسدلة',
  'nav.pagination-basic': 'ترقيم صفحات أساسي',
  'nav.pagination-sizing': 'تحديد حجم الترقيم',
  'nav.large': 'كبير',
  'nav.small': 'صغير',
  'nav.center': 'وسط',
  'nav.pagination-alignment': 'محاذاة الترقيم',
  'nav.breadcrumb-basic': 'شريط تنقل أساسي',


  /* 07.17.Popover & Tooltip */
  'popover-tooltip.popover': 'منبثقة (Popover)',
  'popover-tooltip.tooltip': 'تلميح (Tooltip)',

  /* 07.18.Sortable */
  'sortable.columns': 'ترتيب الأعمدة',
  'sortable.basic': 'أساسي',
  'sortable.handles': 'مقابض',

  /* 07.19.Maps */
  'maps.google': 'جوجل',
  'maps.yandex': 'ياندكس',

  /* 07.20.Tables */
  'table.bootstrap-tables': 'جداول التمهيد',
  'table.bootstrap-basic': 'الجدول الأساسي',
  'table.bootstrap-striped': 'صفوف مخططة',
  'table.bootstrap-bordered': 'جدول يحده',
  'table.bootstrap-borderless': 'طاولة بلا حدود',
  'table.bootstrap-hoverable': 'صفوف قابلة للتحويم',
  'table.bootstrap-responsive': 'جدول مستجيب',
  'table.react-tables': 'رد الفعل الجداول',
  'table.react-pagination': 'ترقيم الصفحات',
  'table.react-scrollable': 'للتمرير',
  'table.react-advanced': 'التصفية والطول والقفز',

  /* Property Info */
  'property-info.allcustomers': 'جميع العملاء',
  'property-info.external-sources': 'المصادر الخارجية',
  'property-info.faq': 'الأسئلة الشائعة',
  'property-info.documents': 'المستندات',
  'property-info.publish-ai': 'نشر الذكاء الاصطناعي',
  'property-info.pre-built-templates': 'القوالب الجاهزة',
  'property-info.room-types': 'أنواع الغرف',

  'property-info.about-property': 'حول الملكية',
  'property-info.about-properties': 'حول الخصائص',
  'property-info.facilities-services': 'خدمات التسهيلات',
  'property-info.property-facilities': 'مرافق الملكية',
  'property-info.room-amenities': 'وسائل الراحة في الغرفة',
  'property-info.property-contact': 'جهة اتصال الملكية',
  'property-info.property-activities': 'أنشطة الملكية',
  'property-info.property-location': 'موقع العقار',
  'property-info.about-rooms': 'حول الغرف',
  'property-info.about-sites': 'حول المواقع',
  'property-info.special-emergencies': 'حالات الطوارئ',
  'property-info.gallery': 'صالة عرض',
  'property-info.policies': 'سياسات',
  'property-info.nearby': 'مجاور',
  'property-info.transport': 'ينقل',
  'property-info.location': 'موقع',
  'property-info.about-rhproperty': 'حول بيت التقاعد',
  'property-info.related-topics': 'مواضيع ذات صلة',
  'property-info.assistant-options': 'قائمة المساعد',
  'property-info.restaurant-assistant-information': 'معلومات المطعم',
  'property-info.restaurant-assistant-options': 'رسالة ترحيب',
  'property-info.channel-messages': 'رسائل القناة',
  'property-info.icon.gallery': 'معرض الأيقونات',
  'property-info.copilot': 'مساعد طيار',
  'property-info.sprint': 'سبرينت',
  'property-info.home-information': 'معلومات المنزل',
  'property-info.loction': 'المواقع',
  'property-info.rooms-and-images': 'الغرف والصور',
  'property-info.trainig-data': 'بيانات التدريب',
  'property-info.flows': 'يطفو',
  'property-info.add-your-own': 'اضف اشياءك الخاصة',
  'property-info-utility-miscellaneous': 'متنوع',
  'property-info-utility-payment': 'المدفوعات',
  'property-info-utility-broadband': 'موجة عريضة',
  'property-info-utility-emergency': 'طارئ',
  'property-info-utility-mobile': 'متحرك',
  'property-info-utility-moving': 'متحرك',
  'property-info.publishMonitor': 'النشر والمراقبة',
  'property-info.webWidget': 'عنصر واجهة الويب',
  'property-info.media': 'وسائط',
  /** Rate & Promo */
  'rate-promo.rate-plans': 'خطط الأسعار',
  'rate-promo.rate-plan-addons': 'الإضافات',
  'rate-promo.rate-plan-promos': 'الملل',

  'title.property-information': 'معلومات الملكية',

  'property.message': 'رسالة',
  'property.example': 'مثال',
  'property.link': 'الروابط',
  'property.image-carousel': 'مكتبة الصور',
  'property.Title': 'لقب',
  'property.SubTitle': 'العنوان الفرعي',

  'property.add-invoke-api': 'استدعاء واجهة برمجة التطبيقات',
  'property.add-message-button': 'أضف الرسائل',
  'property.add-img-button': 'إضافة الصور',
  'property.add-link-button': 'إضافة رابط',
  'property.add-herocard-button': 'أضف بطاقة البطل',
  'property.add-api-button': 'أضف الأزرار',

  'menu.settings': 'الإعدادات',
  'menu.workflows': 'سير العمل',
  'menu.product_services': 'المنتجات والخدمات',
  'menu.product_recommander': 'مُوصي المنتج',
  'menu.digital_guide_book': 'الدليل الرقمي',
  'menu.welcome_message': 'رسالة الترحيب',
  'menu.about-property': 'حول العقار',
  'menu.property-facilities': 'مرافق العقار',
  'menu.room-amenities': 'مرافق الغرف',
  'menu.property-contact': 'جهة اتصال العقار',
  'menu.about-rooms': 'الغرف',
  'menu.special-emergencies': 'الطوارئ',
  'menu.show-filter': 'عوامل التصفية',
  'menu.new': 'جديد',
  'menu.channel': 'القنوات',
  'menu.application': 'التطبيقات',

  'dashboards.send': 'إرسال',
  'dashboards.hello': 'مرحباً',
  'dashboards.notificationsAllowed': 'الإشعارات مسموح بها',
  'dashboards.allowNotifications': 'السماح بالإشعارات',
  'dashboards.views': 'المشاهدات',
  'dashboards.bookingURL': 'رابط الحجز',
  'dashboards.searchTags': 'علامات البحث',
  'dashboards.searchCategoryTags': 'علامات فئة البحث',
  'dashboards.bedroom': 'غرفة النوم',
  'dashboards.addBedroom': 'أضف غرفة نوم',
  'dashboards.frequency': 'تكرار',
  'dashboards.includeSubpages': 'تضمين الصفحات الفرعية',
  'dashboards.enableFaqs': 'تمكين الأسئلة المتكررة',
  'dashboards.faqsDescription': 'يسمح لك تمكين الأسئلة المتكررة بإدخال الأسئلة بينما يستخرج النظام الإجابات المقابلة من محتوى صفحة الويب لإنشاء أسئلة شائعة كاملة',
  'dashboards.faq': 'س.و.ج',
  'dashboards.deleteDocument': 'حذف المستند',
  'dashboards.confirmDelete': 'هل أنت متأكد أنك تريد الحذف؟',
  'dashboards.addItem': 'أضف عنصرًا',
  'dashboards.addFirstWebPage': 'أضف أول صفحة ويب لك',



  'dashboards.popular-compendium': '	عناصر قائمة الملخص الشائعة',
  'dashboards.wordcloudofcompendium': 'سحابة كلمات لعناصر قائمة الملخص',
  'dashboards.wordcloudonthings': 'سحابة كلمات حول ما يسأل عنه زوار الموقع وعناصر القائمة',
  'dashboards.common-asked': 'الأسئلة المتداولة',
  'dashboards.website-visitor-asking': 'الأشياء التي يسأل عنها زوار الموقع',
  'dashboards.visit-country': 'زيارة الموقع حسب الدولة',
  'dashboards.visit-traffic': 'بلد حركة الموقع',
  'dashboards.rooms-product': 'الغرف والمنتجات',
  'dashboards.popular-room-product': 'الغرف والمنتجات الشعبية',

  'dashboards.messenger-stats': 'عناصر القائمة الشعبية',
  'dashboards.messenger-stats-topic-view':
    'الإحصائيات في طرق عرض عناصر القائمة',
  'dashboards.messenger-stats-visits': 'طرق عرض عناصر القائمة',
  'dashboards.opening-menu-items': 'عدد زوار الموقع الذين فتحوا عناصر القائمة',
  'dashboards.connect': 'اتصال',
  'dashboards.number-totalavatarclick': 'إجمالي نقرات الصورة الرمزية',
  'dashboards.tickets-by-category': 'تذاكر حسب الفئة',
  'dashboards.download': 'تنزيل',
  'dashboards.clicks': 'نقرات',
  'dashboards.leads': 'يؤدي',
  'dashboards.hours': 'ساعات',
  'dashboards.minutes': 'دقائق',
  'dashboards.subscribe-to-reports': 'اشترك في التقارير',
  'dashboards.ai-chatbot': 'روبوت الدردشة بالذكاء الاصطناعي',
  'dashboards.compendium': 'خلاصة وافية',
  'dashboards.compendium-digital-usage': 'استخدام الخلاصة الرقمية',
  'dashboards.compendium-unique-visits': 'مسح/نقرات رمز الاستجابة السريعة',
  'dashboards.compendium-opening-menu-items': 'عدد عناصر القائمة التي تم عرضها',
  'dashboards.compendium-total-digital-clicks':
    'إجمالي عدد مرات مشاهدة عناصر القائمة',
  'dashboards.compendium-total-qr-code': 'إجمالي عمليات مسح/نقرات رمز الاستجابة السريعة',
  'dashboards.compendium-avg-menu-items': 'متوسط ​​عدد مرات عرض عناصر القائمة لكل مسح ضوئي',

  'property.delete': 'حذف',
  'menu.userroles': 'المستخدمون والأدوار',
  'menu.members': 'أعضاء',
  'menu.guest-pass': 'تصريح الضيف',
  'menu.ratebookings': 'الأسعار والحجوزات',
  'dashboards.engagement-time': 'وقت تفاعل المساعد الرقمي',
  'dashboards.conversations-minutes':
    'إجمالي الدقائق والمبيت (7 مساءً إلى 7 صباحًا) دقائق المحادثات',
  'dashboards.visitor-questions': 'أسئلة الزائر',
  'dashboards.recent-queries': 'الاستفسارات الأخيرة',
  'dashboards.visitor-saying': 'ما يقوله زوار موقعك للمساعد الرقمي',
  'dashboards.contacts-prechatform-leavemessage':
    'جهات الاتصال المخزنة من نموذج ما قبل الدردشة وترك رسالة',


  'menu.dashboards': 'أفكار',
  'menu.ari': 'التوفر والأسعار',
  'menu.conversations': 'المحادثات',
  'menu.conversations.unified-inbox': 'البريد الوارد الموحد',
  'menu.conversations.active': 'الدردشات النشطة',
  'menu.conversations.archives': 'أرشيف',
  'menu.conversations.missed-responses': 'الردود الفائتة',
  'menu.conversations.ticket': 'تذاكر',
  'menu.conversations.reply-templates': 'قوالب الرد',
  'menu.bookings': 'الحجوزات والحجوزات',
  'menu.tickets': 'العروض والتذاكر',
  'menu.propinfo': 'مركز المعرفة',
  'menu.rate-promos': 'الأسعار والترقيات',
  'menu.finance': 'تمويل',
  'menu.integration': 'يتصل',
  'menu.admin': 'الإدارة والأمان',
  'menu.favourites': 'المفضلة',
  'menu.recommender': 'تدفق المحادثة',
  'menu.assistant-setup': 'إعداد المساعد',
  'menu.admin-insights': 'رؤى المشرف',
  'menu.super-admin': 'المشرف الفائق',
  'menu.groups': 'المجموعات',
  'menu.properties': 'ملكيات',
  'menu.service-provider': 'مقدمو الخدمة',
  'menu.spaces': 'المساحات',
  'menu.content-manager': 'مدير المحتوى',
  'menu.events-calendar': 'تقويم الأحداث',
  'menu.appearance-settings': 'المظهر والإعدادات',
  'menu.availability': 'التوفر',
  'menu.help': 'مساعدة',
  'menu.myAccounts': 'حساباتي',
  'menu.guest-messaging': 'رسائل الضيوف',

  'dashboards.space-booking': 'حجز الفضاء',
  'dashboards.gift-voucher': 'قسائم الهدايا',
  'dashboards.chatbots': 'روبوتات الدردشة',
  'dashboards.form': 'من',
  'dashboards.to': 'ل',
  'dashboards.active-groups': 'المجموعات النشطة',
  'dashboards.active-properties': 'الخصائص النشطة',
  'dashboards.live-properties': 'خصائص حية',
  'dashboards.properties-going': 'يتم عرض العقارات حسب النطاق الزمني',
  'dashboards.start-date': 'تاريخ البدء',
  'dashboards.end-date': 'تاريخ الانتهاء',

  'dashboards.website-visits': 'زيارات الموقع',
  'dashboards.unique-visitors': 'زائرين فريدين من نوعهم',
  'dashboards.last-week': 'الاسبوع الماضى',
  'dashboards.this-week': 'هذا الاسبوع',
  'dashboards.this-month': 'هذا الشهر',
  'dashboards.previous-month': 'الشهر الماضى',
  'dashboards.yeartodate': 'منذ بدلية العام ز حتى اليوم',
  'dashboards.lastyear': 'العام الماضي',
  'dashboards.last-7-days': 'اخر 7 ايام',
  'dashboards.last-30-days': 'آخر 30 يومًا',
  'dashboards.last-60-days': 'آخر 60 يومًا',
  'dashboards.last-90-days': 'آخر 90 يومًا',
  'dashboards.conversion-rates': 'أسعار التحويل',
  'dashboards.digital-assistant-engagement': 'مشاركة المساعد الرقمي',
  'dashboards.total-overnight-conversations':
    'المحادثات الإجمالية والمبيتة (7 مساءً إلى 7 صباحًا).',
  'dashboards.percentage-accuracy': 'تغطية المعرفة',
  'dashboards.percentage-conversion': 'حركة مرور الموقع إلى تحويل الدردشة',
  'dashboards.percentage-avatarclick':
    'حركة مرور موقع الويب إلى نقرات الصورة الرمزية',
  'dashboards.percentage-negativefeedback':
    'التعليقات السلبية كنسبة مئوية من نقرات الصورة الرمزية',
  'dashboards.percentage-amenties': 'استفسارات الراحة',
  'dashboards.percentage-booking': 'استفسارات الحجز',
  'dashboards.percentage-webchats': 'موقع الدردشات',
  'dashboards.percentage-facebookchat': 'دردشات فيسبوك',
  // 'dashboards.number-webchattime': 'إجمالي وقت محادثة الويب',
  'dashboards.number-webchattime': 'إجمالي وقت المحادثة',
  'dashboards.number-totalconversation': 'إجمالي المحادثات',
  'dashboards.number-websiteconversation': 'محادثات الموقع',
  'dashboards.number-facebookconversation': 'محادثات الفيسبوك',
  'dashboards.number-estimatedtimesaving': 'التوفير في الوقت المقدر',
  'dashboards.number-googlemapsconversation': 'محادثات خرائط جوجل',
  'dashboards.number-whatsappconversation': 'محادثة واتس اب',
  'dashboards.number-instagramconversation': 'محادثات انستغرام',
  'dashboards.number-agentconversation': 'محادثات الوكيل',
  'dashboards.number-amenityqueries': 'استفسارات الراحة',
  'dashboards.number-bookingenquiries': 'استعلامات الحجز',
  'dashboards.number-groupbookingenquiries': 'استفسارات حجز المجموعة',
  'dashboards.number-eventenquiries': 'استفسارات الحدث',
  'dashboards.number-longstayenquiries': 'استفسارات الإقامة الطويلة',
  'dashboards.number-totaltickets': 'تذاكر',
  'dashboards.number-returncustomer': 'عودة الزبون',
  'dashboards.number-redirects': 'عمليات إعادة توجيه موقع الويب',
  'dashboards.number-bookingengineleads': 'يؤدي محرك الحجز',
  'dashboards.number-roomnightsreferred': 'ليالي الغرفة المشار إليها',
  'dashboards.number-revenuereferred': 'الإيرادات المحالة',
  'menu.bookingsmenu': 'الحجوزات',
  'menu.guests': 'معلومات الزوار',
  'menu.whatsnew': 'ما هو الجديد',
  'forms.forms-title': 'نماذج',
  'menu.formbuilder': 'منشئ النموذج',
  "dashboards.trainAI": "درّب الذكاء الاصطناعي باستخدام المستندات",
  "dashboards.uploadDocuments": "حمّل مستندات لمساعدة الذكاء الاصطناعي على التعرف على عملك ومساعدة العملاء كما لو كنت أنت. يمكنك إضافة ملفات بصيغة .doc أو .pdf أو .txt.",
  'dashboards.welcomeMessage': 'رسالة الترحيب',
  'dashboards.personalizeGreeting': 'خصص طريقة تحية العملاء لتعكس علامتك التجارية وأسلوبك وآدابك، لضمان حصولهم على أحر ترحيب. قم بتخصيص التحيات لتعكس علامتك التجارية وتخلق ترحيبًا دافئًا.',
  'dashboards.addRoomDetails': 'أضف تفاصيل عن كل غرفة من غرفك حتى يتمكن الضيوف بسهولة من اكتشاف كل ما يحتاجونه لاختيار الخيار المثالي وجعل عملية الحجز أبسط وأسرع.',
  'dashboards.trainAIFAQs': 'درّب الذكاء الاصطناعي بالأسئلة الشائعة',
  'dashboards.manualQuestions': 'بعض الأسئلة لا يمكن الإجابة عليها بواسطة المستندات أو العثور عليها على الموقع. هنا، يمكنك إضافة الأسئلة يدويًا لضمان حصول العملاء دائمًا على المعلومات التي يحتاجونها بين يديهم.',
  'dashboards.publishAI': 'انشر الذكاء الاصطناعي ليعكس أحدث التحديثات',
  'dashboards.retrainAfterChanges': 'عندما تقوم بإجراء تغييرات في مركز المعرفة أو النماذج، تأكد من إعادة تدريب الدردشة الآلية على المعلومات المحدثة. إن نشر الذكاء الاصطناعي يضمن أن يوفر الروبوت الإجابات الأكثر دقة وحداثة.',
  'dashboards.enhanceKnowledge': 'عزز معرفة الذكاء الاصطناعي بتتبع الاستفسارات غير المجابة',
  'dashboards.reviewUnanswered': 'عندما لا يتمكن الذكاء الاصطناعي من الإجابة على سؤال أو يقدم تفاصيل محدودة فقط، ستجد تلك الاستفسارات هنا. راجعها لتحديد الفجوات في مركز المعرفة أو الأسئلة الفريدة من الضيوف.',
  'dashboards.manageMedia': 'إدارة الوسائط',
  'dashboards.mediaGallery': 'عند تحميل صور مثل الغرف، والمرافق، والشعارات، أو صورتك الرمزية الرقمية، ستظهر في هذه المعرض، مما يمنحك مكانًا مركزيًا لإدارة المرئيات وضمان أن يرى ضيوفك ما يميز عملك.',
  'dashboards.createForms': 'أنشئ النماذج بسهولة وتلقى إشعارًا عند كل تقديم.',
  'dashboards.manageForms': 'أنشئ وإدارة النماذج لجمع معلومات العملاء، ضبط الإشعارات، وتخصيصها بلغات مختلفة.',
  'dashboards.personalizeResponse': 'خصص أسلوب الرد وتطور المحادثة',
  'dashboards.controlConversation': 'تتيح لك هذه الميزة المتقدمة القدرة على تشكيل والسيطرة على كيفية سير المحادثات مع عملائك عبر قنوات مختلفة.',

  'menu.virtualfrontdesk': 'مكتب أمامي افتراضي',
  'menu.guestservice': 'خدمات الضيوف',
  'virtual-front.common-questions': 'الأسئلة الشائعة',
  'virtual-front.add-on-upsells': 'الإضافات & Upsells',
  'virtual-front.service-order': 'أوامر الخدمة',
  // 'virtual-front.guest-service-add-on-upsells': "خدمات الضيوف والإضافات",
  'virtual-front.guest-service-add-on-upsells': 'سجل الزوار الرقمي',
  'virtual-front.outbound': 'الصادرة',
  'virtual-messenger': 'رسول',

  'missed-response.missed-response-title': 'عنوان الرد مفقود',

  //unified-inbox 
  'content.allconversation': 'جميع المحادثات',
  'content.active': 'نشطة',
  'content.tickets': 'تذاكر',
  'content.filter': 'تصفية',
  'content.createtickets': 'إنشاء تذاكر',
  'content.conversation': 'محادثة',
  'content.knowledgesearch': 'بحث في قاعدة المعرفة',
  'content.reply': 'رد',
  'content.visitorinfo': 'معلومات الزائر',
  'content.callinfo': 'معلومات المكالمة',
  'content.allinsights': 'جميع الرؤى',
  'content.availabilityrates': 'التوافر والأسعار',
  'content.callback': 'إعادة الاتصال',
  'content.close': 'إغلاق',
  'content.sms': 'رسالة نصية',
  'content.timestamp': 'الطابع الزمني',
  'content.topics': 'المواضيع',
  'content.callingparty': 'الطرف المتصل',
  'content.accountdomain': 'نطاق الحساب',
  'content.calledparty': 'الطرف المُتصل به',
  'content.recording': 'تسجيل',
  'content.phonesystemoriginationcallid': 'معرف مكالمة المنشأ لنظام الهاتف',
  'content.phonesystemterminationcallid': 'معرف مكالمة الانتهاء لنظام الهاتف',
  'content.uniqueconversationid': 'معرف المحادثة الفريد',
  'content.regenerateinsights': 'إعادة توليد الرؤى',
  'content.customersentiment': 'مشاعر العميل',
  'content.neutral': 'محايد',
  'content.customerreportedbroadbandoutage': 'أبلغ العميل عن انقطاع في خدمة الإنترنت مع تقديم معرف العميل وتاريخ تفعيل الخدمة للحصول على المساعدة.',
  'content.conversationinsights': 'رؤى المحادثة',
  'content.broadbandoutage': 'انقطاع خدمة الإنترنت',
  'content.customeridverification': 'التحقق من معرف العميل',
  'content.serviceactivationdate': 'تاريخ تفعيل الخدمة',
  'content.followups': 'متابعات',
  'content.actionneeded': 'يتطلب اتخاذ إجراء',
  'content.uniqueConversationId': 'معرّف المحادثة الفريد',
  'content.uniqueChatId': 'معرّف الدردشة الفريد',
  'content.recording&transcript': 'التسجيل والنص',
  'content.chatinsights': 'رؤى الدردشة',
  'content.visitedpages': 'الصفحات المُزارة',
  'content.deviceinfo': 'معلومات الجهاز',
  'content.chatstartedonthispage': 'بدأت الدردشة على هذه الصفحة',
  'content.prechatinfo': 'معلومات ما قبل الدردشة',
  'content.notes': 'ملاحظات',
  'content.reassign': 'إعادة التعيين',
  'content.open': 'فتح',
  "content.dismiss": "إغلاق",
  "content.add_placeholder": "إضافة قيم العناصر النائبة",
  "content.mobile_number": "رقم الجوال",
  "content.please_select": "يرجى الاختيار",
  'content.sendwhatsapp': 'إرسال رسالة واتساب',


  /*Missed Response */
  'feedback.missed-question': 'سؤال لم يتم الرد عليه',
  'feedback.conversation-summary': 'ملخص المحادثة',
  'feedback.dates-in-spanish': 'يجب أن تكون التواريخ باللغة الإسبانية',
  'feedback.resolve': 'حلّ',
  'feedback.ignore': 'تجاهل',

  /*Integration */
  'integration.select_properties': 'تحديد الخصائص',
  'integration.select_properties_enabled': 'تحديد الخصائص المفعّلة من خلال هذا التكامل',
  'integration.services_addons': 'تحديد الخدمات والإضافات',
  'integration.services_visible': 'تحديد الخدمات والإضافات التي ستظهر في هذه الصفحة',
  'integration.appearance': 'المظهر',
  'integration.appearance_customize': 'اختر اسم مساعدك الرقمي، الصورة الرمزية، وأعدّ ألوانك',
  'integration.booking_calendar': 'تقويم الحجز',
  'integration.booking_calendar_style': 'اختر تنسيق النافذة المنبثقة لتقويم الحجز',
  'integration.nudges': 'التنبيهات',
  'integration.nudges_setup': 'إعداد الرسائل التفاعلية لجذب زوار الموقع',
  'integration.position': 'الموضع',
  'integration.position_control': 'تحكم في موقع أداة الدردشة على موقعك',
  'integration.custom_fonts': 'الخطوط المخصصة',
  'integration.custom_fonts_upload': 'قم بتحميل أي خطوط مخصصة تريد استخدامها للصفحة',
  'integration.custom_css': 'CSS مخصص',
  'integration.custom_css_usage': 'استخدم CSS لتخصيص وصفك الرقمي',
  'integration.location': 'الموقع',
  'integration.location_embed': 'أضف رابط تضمين الموقع',
  'integration.external_links': 'روابط خارجية',
  'integration.external_links_add': 'أضف روابطك',
  'integration.language': 'اللغة',
  'integration.widget_languages': 'اختر اللغات لأداة الدردشة',
  'integration.chatbot_contact': ' الاتصال',
  'integration.chatbot_enable': 'تشغيل مساعدك الرقمي',
  'integration.chatbot_security': 'حافظ على أمان المراسلة الخاصة بك',
  'integration.chatbot_trusted_pages': 'أدرج الصفحات الموثوقة لعرض الدردشة فيها',
  'integration.chatbot_publish': 'نشر مساعدك الرقمي',
  'integration.chatbot_install': 'انسخ شفرة التضمين لتثبيت مساعدك الرقمي',

  'guest-messaging.settings': 'الإعدادات',
  'guest-messaging.outreach-setup': 'إعداد التوعية',
  'guest-messaging.reservations': 'الحجوزات',
  'guest-messaging.reservation-source': 'مصدر بيانات الحجز',
  'guest-messaging.communication-channels': 'قنوات الاتصال',
  'guest-messaging.templates': 'القوالب',
  'guest-messaging.link': 'الرابط',
  'guest-messaging.business-profile': 'الملف التجاري',
  'guest-messaging.insights_logs': 'التحليلات والسجلات',


};
export default arMessages;